module.exports = __webpack_public_path__ + "static/media/ticketSignatureCheck.7f000c29.svg";